export default "__VITE_ASSET__BFCUbnwz__"